import { AttachConfirmationModalProps } from '@v2/components/imageHandling/components/Header/components/AttachModal/AttachConfirmationModal';
import { SearchItemType } from '@interfaces/base';

interface UseManageAttachConfirmationModal extends Pick<AttachConfirmationModalProps, 'itemType'> {}

export const useManageAttachConfirmationModal = ({itemType}: UseManageAttachConfirmationModal) => {

  const getItemTypeText = (type: SearchItemType) => {
    const mapping = {
      Part: 'part',
      NcFile: 'NC file',
      ProductionBatch: 'batch',
      ProductionOrder: 'production order',
      Operation: 'operation',
      Tool: 'tool',
      ImageDocument: 'document',
    };
    return mapping[type] || 'item';
  };

  const typeText = getItemTypeText(itemType);

  return { typeText };
};
